import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useLang } from "@/context/LanguageContext";
import { t } from "@/lib/i18n";
import { CheckCircle2, Download, ArrowUpRight } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function EbookSuccessPage() {
  const [params] = useSearchParams();
  const { lang } = useLang();
  const [status, setStatus] = useState(null);
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) return;
    let cancel = false, n = 0;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${BACKEND_URL}/api/ebooks/checkout/${sessionId}`);
        if (cancel) return;
        setStatus(data);
        if (data.payment_status !== "paid" && n < 15) { n += 1; setTimeout(poll, 1500); }
      } catch {/* ignore */}
    };
    poll();
    return () => { cancel = true; };
  }, [sessionId]);

  const paid = status?.payment_status === "paid";
  const downloadUrl = status?.download_url ? `${BACKEND_URL}${status.download_url}` : null;

  return (
    <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center p-6" data-testid="ebook-success-page">
      <div className="max-w-md w-full text-center">
        <div className={`w-16 h-16 mx-auto rounded-full border flex items-center justify-center mb-6 ${
          paid ? "border-[color:var(--hq-success)] text-[color:var(--hq-success)]" : "border-white/20 text-white/40"
        }`}>
          <CheckCircle2 size={32} />
        </div>
        <h1 className="font-display font-light text-3xl tracking-tight">
          {paid ? t(lang, "ebooks_success_title") : t(lang, "ebooks_success_pending")}
        </h1>
        <p className="mt-3 text-white/60 text-sm">
          {paid ? t(lang, "ebooks_success_body") : t(lang, "ebooks_success_pending_body")}
        </p>
        {paid && downloadUrl && (
          <a
            data-testid="ebook-download-btn"
            href={downloadUrl}
            className="hq-btn hq-btn-primary mt-6 inline-flex"
          >
            <Download size={14} /> {t(lang, "ebooks_download_now")}
          </a>
        )}
        {status?.email && (
          <div className="mt-4 font-mono text-[10px] uppercase text-white/40">
            {t(lang, "ebooks_email_sent_to")} {status.email}
          </div>
        )}
        <div className="mt-8">
          <Link to="/shop/ebooks" className="hq-btn hq-btn-ghost text-xs">
            {t(lang, "ebooks_browse_more")} <ArrowUpRight size={12} />
          </Link>
        </div>
      </div>
    </div>
  );
}
